import { Box, Button, TextField, Typography, useMediaQuery, useTheme} from "@mui/material"
import SoopraLogo from "../../svg/SoopraLogo"
import { useState } from "react";
import { toast } from "react-toastify";
import EmailSubscribeBox from "../../component/EmailSubscribeBox";


const TransitionValueProp = () => {
    const showEmailInput = true
    const [stayUpdatedInput, setStayUpdatedInput] = useState<string>("")
    const theme = useTheme();

    const isXs = useMediaQuery(theme.breakpoints.down('sm'));
    const handleSubmitForm = () => {
        console.log(stayUpdatedInput)
        setStayUpdatedInput('')
        toast.success('We will keep you updated!')
    }
    
  return (
    <Box
        sx={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            width: "100%",
            minHeight: "100dvh",
            p: {xs:2,md:0},
            gap: 4,
        }}
    >
        <Box>
            <SoopraLogo color={theme.palette.primary.main}/>
        </Box>
        <Box 
            sx={{
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center",
                width: "100%",
                gap:2,
                textAlign: "center"
            }}
        >
            <Typography variant={isXs?"h4":"h3"} color="text.primary">Contest Complete!</Typography>
            <Typography variant={isXs?"h7":"h6"} color="text.primary">🏆 Winners revealed 🏆</Typography>
            <Typography variant="body1" color="text.secondary">Personas were created. Questions were asked and answered. Prizes were won.<br/>Thank you to everyone who participated and congratulations to the winners.</Typography>
        </Box>
        {showEmailInput && 
            <Box
                sx={{
                    width: {xs:'90%', md:'55%'}
                }}
            >
                <EmailSubscribeBox 
                    formType="contest"
                    title="Stay updated about the next contest"
                    subtitle="No spam, unsubscribe anytime. Contest updates only."
                />
            </Box>
        }

    </Box>
  )
}

export default TransitionValueProp